import {
    ListarExecucoesManuaisETLService,
    VoltarDataETLService,
} from "../../../Services/Geral/ExecutarETL/ExecutarETLService";
import { Controller } from "../../Controller";

export async function ListarExecucoesManuaisETLController() {
    return Controller(ListarExecucoesManuaisETLService());
}

export async function VoltarDataETLController() {
    return Controller(VoltarDataETLService());
}
